import React from 'react'
import ListSpan from '../../common/ListSpan'

function PatientCommPref() {
  /*
  "id": 1944,
    "patientId": 25931,
    "isEmail": 0,
    "isSms": 1,
    "isCall": 1,
    "isLiveCall": 0,
    "prefEmail": 0,
    "prefSms": 1,
    "prefCall": 3,
    "prefLiveCall": 0,
    "reminderStatus": 1,
    "newsletterStatus": 1,
    "articleStatus": 0,
    "recallStatus": 0,
    "glassStatus": 0,
    "lensStatus": 0,
    "lensOrderStatus": 0,
    "thankyouStatus": 0,
    "surveyStatus": 0,
    "followupStatus": 0,
    "birthdayStatus": 0,
  */
  return (
    <>
      <div className="d-flex justify-content-end">
        <button className="btn btn-light-success btn-sm">Save Changes</button>
      </div>
      <div className="row">
          <div className="col-6">
          <ul className='list-group-flush'>
             
                <ListSpan 
                value={1}
                text = "Reminder"
                subtext = "Send a reminder to the patient"
              />
                <ListSpan 
                value={1}
                text = "Newsletter"
                subtext = "Send a newsletter to the patient"
              />
                <ListSpan 
                value={1}
                text = "Article"
                subtext = "Send an article to the patient"
              />
                <ListSpan 
                value={1}
                text = "Recall"
                subtext = "Send a recall to the patient"
              />
                <ListSpan 
                value={1}
                text = "Glass Pickup"
                subtext = "Send a glass pickup to the patient"
              />
                <ListSpan 
                value={1}
                text = "Lens Pick"
                subtext = "Send a lens pickup to the patient"
              />
                <ListSpan 
                value={1}
                text = "Lens Order"
                subtext = "Send a lens order to the patient"
              />
                <ListSpan 
                value={1}
                text = "Thank you"
                subtext = "Send a thank you to the patient"
              />
                <ListSpan 
                value={1}
                text = "Survey"
                subtext = "Send a survey to the patient"
              />
                <ListSpan 
                value={1}
                text = "Follow up"
                subtext = "Send a follow up to the patient"
              />
                <ListSpan 
                value={1}
                text = "Birthday"
                subtext = "Send a birthday wishes to the patient"
              />
          </ul>
          </div>
          <div className="col-6">
                <div className="card mt-3">
                  <div className="card-body">
                    <h5 className="card-title">Contact Preferences</h5>
                    <p className="card-text">
                      You can change your contact preferences here.
                    </p>

                    <div className="d-flex align-items-center bg-light-warning rounded p-5 mb-7">
                      <i className="bi bi-envelope text-warning fs-1 me-5"></i>
                      <div className="flex-grow-1 me-2">
                        <span className="fw-bold text-gray-800 text-hover-primary fs-6">Email</span>
                        <span className="text-muted fw-semibold d-block">First Preference</span>
                        </div>  
                        <i className="bi bi-arrow-down-up"></i>
                    </div>

                    <div className="d-flex align-items-center bg-light-info rounded p-5 mb-7">
                      <i className="bi bi-chat-left-dots text-info fs-1 me-5"></i>
                      <div className="flex-grow-1 me-2">
                        <span className="fw-bold text-gray-800 text-hover-primary fs-6">Sms</span>
                        <span className="text-muted fw-semibold d-block">Second Preference</span>
                        </div>  
                        <i className="bi bi-arrow-down-up"></i>
                    </div>

                    <div className="d-flex align-items-center bg-light-success rounded p-5 mb-7">
                      <i className="bi bi-telephone-outbound text-success fs-1 me-5"></i>
                      <div className="flex-grow-1 me-2">
                        <span className="fw-bold text-gray-800 text-hover-primary fs-6">Call</span>
                        <span className="text-muted fw-semibold d-block">Third Preference</span>
                        </div>  
                        <i className="bi bi-arrow-down-up"></i>
                    </div>

                  </div>
                </div>
          </div>
      </div>
    </>
  )
}

export default PatientCommPref